import { useEffect, useState } from "react";
import { NutritionalValues } from "../models/aliments/nutritionalValues.ts";
import { FormInput } from "./form";
import React from "react";
import CustomIcon from "./CustomIcon.tsx";
import formatNumber from "../models/helpers/formatNumber.ts";

const NutritionalValuesComponent = ({
    nutritionalValues,
    handleInputChange,
    canEdit = false,
    errors,
    measurementUnit = 'g',
}: {
    nutritionalValues: NutritionalValues | null;
    handleInputChange?: any;
    canEdit?: boolean;
    errors?: any;
    measurementUnit?: string;
}) => {
    const [showMore, setShowMore] = useState<boolean>(canEdit);
    useEffect(() => {
        setShowMore(canEdit)
    }, [canEdit])
    if (nutritionalValues === null) return null;
    return (
        <div className='mb-3'>
            <div className="d-flex flex-row">
                <h6>Nutritional Values</h6>
                <small className="ms-1">for 100{measurementUnit ?? 'g'}</small>
                <i className={`bi bi-chevron-${showMore ? 'up' : 'down'} ms-1`} onClick={() => setShowMore(!showMore)} />
            </div>
            {showMore == false &&
                <ul className="list-group">
                    <li className="list-group-item d-flex flex-row justify-content-between px-2">
                        <div className="w-25 my-auto text-center">
                            {formatNumber.ToFixed(nutritionalValues.calories)}kCal
                        </div>
                        <div className="w-25 my-auto text-center text-success">
                            <CustomIcon name='protein' />
                            {formatNumber.ToFixed(nutritionalValues.protein)}g
                        </div>
                        <div className="w-25 my-auto text-center text-warning">
                            <CustomIcon name='carbohydrates' />
                            {formatNumber.ToFixed(nutritionalValues.carbohydrates)}g
                        </div>
                        <div className="w-25 my-auto text-center text-danger">
                            <CustomIcon name='fat' />
                            {formatNumber.ToFixed(nutritionalValues.totalFat)}g
                        </div>
                    </li>
                </ul>
            }
            {showMore &&
                <>
                    <FormInput
                        entity={nutritionalValues}
                        handleInputChange={handleInputChange}
                        fieldName='calories'
                        label='Calories'
                        type="decimal"
                        append="kCal"
                        toFixed={!canEdit ? 2 : undefined}
                        mb={1}
                        disabled={!canEdit}
                        errors={errors}
                    />
                    <FormInput
                        entity={nutritionalValues}
                        handleInputChange={handleInputChange}
                        fieldName='totalFat'
                        label='Total Fat'
                        type="decimal"
                        append="g"
                        toFixed={!canEdit ? 2 : undefined}
                        mb={1}
                        disabled={!canEdit}
                        errors={errors}
                    />
                    <FormInput
                        entity={nutritionalValues}
                        handleInputChange={handleInputChange}
                        fieldName='saturatedFat'
                        label='Saturated Fat'
                        type="decimal"
                        append="g"
                        toFixed={!canEdit ? 2 : undefined}
                        mb={1}
                        disabled={!canEdit}
                        errors={errors}
                    />
                    <FormInput
                        entity={nutritionalValues}
                        handleInputChange={handleInputChange}
                        fieldName='unsaturatedFat'
                        label='Unsaturated Fat'
                        type="decimal"
                        append="g"
                        toFixed={!canEdit ? 2 : undefined}
                        mb={1}
                        disabled={!canEdit}
                        errors={errors}
                    />
                    <FormInput
                        entity={nutritionalValues}
                        handleInputChange={handleInputChange}
                        fieldName='carbohydrates'
                        label='Carbohydrates'
                        type="decimal"
                        append="g"
                        toFixed={!canEdit ? 2 : undefined}
                        mb={1}
                        disabled={!canEdit}
                        errors={errors}
                    />
                    <FormInput
                        entity={nutritionalValues}
                        handleInputChange={handleInputChange}
                        fieldName='dietarySugar'
                        label='Dietary Sugar'
                        type="decimal"
                        append="g"
                        toFixed={!canEdit ? 2 : undefined}
                        mb={1}
                        disabled={!canEdit}
                        errors={errors}
                    />
                    <FormInput
                        entity={nutritionalValues}
                        handleInputChange={handleInputChange}
                        fieldName='fibre'
                        label='Fibre'
                        type="decimal"
                        append="g"
                        toFixed={!canEdit ? 2 : undefined}
                        mb={1}
                        disabled={!canEdit}
                        errors={errors}
                    />
                    <FormInput
                        entity={nutritionalValues}
                        handleInputChange={handleInputChange}
                        fieldName='protein'
                        label='Protein'
                        type="decimal"
                        append="g"
                        toFixed={!canEdit ? 2 : undefined}
                        mb={1}
                        disabled={!canEdit}
                        errors={errors}
                    />
                    <FormInput
                        entity={nutritionalValues}
                        handleInputChange={handleInputChange}
                        fieldName='salt'
                        label='Salt'
                        type="decimal"
                        append="g"
                        toFixed={!canEdit ? 2 : undefined}
                        mb={1}
                        disabled={!canEdit}
                        errors={errors}
                    />
                </>
            }
        </div>
    )
}

export default NutritionalValuesComponent;